module.exports = __webpack_public_path__ + "assets/img/rateCircle.479631c2.gif";